export const CENTRO_COSTO_FILTER_OPTIONS = [
  { value: '', label: 'Centro de costo' },
  { value: 'asignado', label: 'Asignado' },
  { value: 'no-asignado', label: 'No asignado' }
]

const hasAssignmentValue = value => {
  if (Array.isArray(value)) return value.some(hasAssignmentValue)

  if (value && typeof value === 'object') {
    return Object.keys(value).length > 0
  }

  if (typeof value === 'string') {
    const normalized = value.trim()
    return normalized !== '' && normalized !== '-' && normalized !== '[]'
  }

  return Boolean(value)
}

export const rowHasCentroCosto = row => {
  if (!row || typeof row !== 'object') return false

  const centroCosto =
    row.centroCosto ?? row.centroCostos ?? row.centro ?? row.centrosCosto ?? null

  if (hasAssignmentValue(centroCosto)) return true

  const relatedRows = [row.auxiliar, row.linkage, row.movimientos, row.rows].flatMap(value => {
    if (Array.isArray(value)) return value
    return value ? [value] : []
  })

  return relatedRows.some(rowHasCentroCosto)
}

export const matchesCentroCostoFilter = (row, filter) => {
  if (!filter) return true
  const isAssigned = rowHasCentroCosto(row)
  return filter === 'asignado' ? isAssigned : !isAssigned
}
